import React, { Component } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import Select from "react-select";
import update from "immutability-helper";
import { validated } from "react-custom-validation";
import validator from "validator";
import { format } from "date-fns";
import $ from "jquery";
import { GET_FORMPOST, GET_DETAILDATA } from "../../../actions";
import { apiUrl, masterheaderconfig } from "../../Helpers/Config";
import {
  showLoader,
  hideLoader,
  showAlert,
  userID,
  decodeValue,
  isSingleSelect
} from "../../Helpers/SettingHelper";
import PageLoader from "../../Helpers/PageLoader";
import Header from "../Layout/Header";
import Topmenu from "../Layout/Topmenu";
import Footer from "../Layout/Footer";
import Switch from "react-switch";
var todayDate = new Date();
class Clientform extends Component {
  constructor(props) {
    super(props);
    var editID = "";
    if (this.props.match.path === "/masterpanel/client/edit/:clientID") {
      editID = this.props.match.params.clientID;
    }
    this.state = {
      editID: editID,
      pageloading: false,
      clientdata: {
        companyName: "",
        companyUsername: "",
        companyPassword: "",
        companyCPassword: "",
        companyEmail: "",
        companyContactNumber:"",
        companyWebSite:"",
        companyCountry: "",
        companyCurrency: "",
        companyLanguage: "",
        companyDateFormat: "",
        companyTimeFormat: "",
        companyEnableMenu: false,
        companyEnableTAT: false,
        companyEnableZoneValueBaseDeliveryCharge: false,
        companyEnableGuestCheckout: false,
        companyEnableMaintenanceMode: false,
        companyEnablePromocode: false,
        companyEnableLoyalty: false,        
        companyEnableNewSignupPromocode: false,
        companyEnableHoliday: false,
        companyEnableOrderCount: false,
        companyEnableTax: false,
        companyEnableHighlightProduct: false,
        companyEnableProductTimeAvailability: false,
        companyEnableProductspecialDays: false,
        companyEnableProductRating: false,
        companyEnableStock: false,
        companyAvailability: [],
        companyEnableRapyd:false,
        companyrapydmode:false,
        companyrapydaccesskey: "",
        companyrapydsecretkey: "",
        companyEnableStripe:false,
        companyStripeSecretKey: "",
        companyStripePublicKey: "",
        companyStatus: "",
        action: "add",
      },
      loading: true,
      checked: true,
      countryList: [],
      currencyList: [],
      languageList: [],
      formpost: [],
      availabiltyList: [],
      companyDetail: [],
    };
    this.handleChange = this.handleChange.bind(this);
  }
  componentDidMount() {
    this.loadCountyList();
    this.loadCurrency();
    this.loadLanguage();
    this.loadAvailabilty();

    if (this.state.editID !== "") {
      var params = {
        url: `${apiUrl}company/details/${this.state.editID}`,
        type: "master",
      };
      this.setState({ pageloading: true });
      this.props.getDetailData(params);
    }
  }
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (
      this.state.formpost !== nextProps.formpost &&
      this.props.formpost !== nextProps.formpost
    ) {
      if (nextProps.formpost.length > 0) {
        hideLoader("submit_frm", "class");
        var errMsg = nextProps.formpost[0].message;
        if (nextProps.formpost[0].status === "success") {
          showAlert("Success", errMsg, "success");
          this.props.history.push("/masterpanel/client");
        } else {
          showAlert("Error", errMsg, "error");
        }
      }
    }
    if (
      this.state.companyDetail !== nextProps.detaildata &&
      this.state.editID !== ""
    ) {
      this.setState({ companyDetail: nextProps.detaildata }, function () {
        if (nextProps.detaildata[0].status === "ok") {
          var result = nextProps.detaildata[0].result;

          const companyrapydaccesskey = result?.companyrapydaccesskey ?? '';
          const companyrapydsecretkey = result?.companyrapydsecretkey ?? '';

          const companyStripeSecretKey = result?.companyStripeSecretKey ?? '';
          const companyStripePublicKey = result?.companyStripePublicKey ?? '';

          var companyStatus_txt = "Inactive";
          if (result.companyStatus === "A") {
            companyStatus_txt = "Active";
          } else if (result.companyStatus === "I") {
            companyStatus_txt = "Inactive";
          } else if (result.companyStatus === "D") {
            companyStatus_txt = "Deleted";
          }
          var status =
            result.companyStatus !== "" && result.companyStatus !== null
              ? {
                  label: companyStatus_txt,
                  value: result.companyStatus,
                }
              : "";

          var clientupdatedata = {
            companyName: result.companyName,
            companyUsername: result.companyUsername,
            companyPassword: "",
            companyCPassword: "",
            companyEmail: result.companyEmail,
            companyContactNumber:result.companyContactNumber,
            companyWebSite:result.companyWebSite,
            companyCountry: {
              label: result.companyCountryName,
              value: result.companyCountry,
            },
            companyCurrency: {
              label: result.companyCurrency,
              value: result.companyCurrency,
            },
            companyLanguage: {
              label: result.companyLanguageName,
              value: result.companyLanguage,
            },
            companyDateFormat:
              result.companyDateFormat !== "" &&
              result.companyDateFormat !== null
                ? {
                    label: format(todayDate, result.companyDateFormat),
                    value: result.companyDateFormat,
                  }
                : "",
              companyTimeFormat:
              result.companyTimeFormat !== "" &&
              result.companyTimeFormat !== null
                ? {
                    label: format(todayDate, result.companyTimeFormat),
                    value: result.companyTimeFormat,
                  }
                : "",
            companyEnableMenu: result?.companyEnableMenu ?? false,
            companyEnableTAT: result?.companyEnableTAT ?? false,
            companyEnableZoneValueBaseDeliveryCharge: result?.companyEnableZoneValueBaseDeliveryCharge ?? false,
            companyEnableGuestCheckout: result?.companyEnableGuestCheckout ?? false,
            companyEnableMaintenanceMode: result?.companyEnableMaintenanceMode ?? false,
            companyEnablePromocode: result?.companyEnablePromocode ?? false,
            companyEnableLoyalty: result?.companyEnableLoyalty ?? false,            
            companyEnableNewSignupPromocode: result?.companyEnableNewSignupPromocode ?? false,
            companyEnableHoliday: result?.companyEnableHoliday ?? false,
            companyEnableOrderCount: result?.companyEnableOrderCount ?? false,
            companyEnableTax: result?.companyEnableTax ?? false,
            companyEnableHighlightProduct: result?.companyEnableHighlightProduct ?? false,
            companyEnableProductTimeAvailability: result?.companyEnableProductTimeAvailability ?? false,
            companyEnableProductspecialDays: result?.companyEnableProductspecialDays ?? false,
            companyEnableProductRating: result?.companyEnableProductRating ?? false,
            companyEnableStock: result?.companyEnableStock ?? false,
            companyAvailability: result.companyAvailability!==null && result.companyAvailability!==""?result.companyAvailability.split(','):[],
            companyEnableRapyd : result?.companyEnableRapyd ??  false,
            companyrapydmode: result?.companyrapydmode || false,
            companyrapydaccesskey: companyrapydaccesskey!=="" && companyrapydaccesskey!==null ?  decodeValue(result?.companyrapydaccesskey):"",
            companyrapydsecretkey: companyrapydsecretkey!=="" && companyrapydsecretkey!==null ? decodeValue(result?.companyrapydsecretkey)
              : "",
            companyEnableStripe:result?.companyEnableStripe || false,
            companyStripeSecretKey: companyStripeSecretKey!=="" && companyStripeSecretKey!==null ?  decodeValue(result?.companyStripeSecretKey):"",
            companyStripePublicKey: companyStripePublicKey!=="" && companyStripePublicKey!==null ?  decodeValue(result?.companyStripePublicKey):"",
            companyStatus: status,
            action: "edit",
          };
          this.setState({ clientdata: clientupdatedata, pageloading: false });
        } else {
          showAlert("Error", "Invalid Company", "error");
        }
      });
    }
  }
  loadCountyList() {
    var urlShringTxt = apiUrl + "common/countryList";

    axios.get(urlShringTxt, masterheaderconfig).then((res) => {
      var countryList = [];
      if (res.data.status === "ok") {
        countryList = res.data.result;
      }
      this.setState({ countryList: countryList });
    }).catch((e) => {
      console.log(e)
    });
  }
  loadCurrency() {
    var urlShringTxt = apiUrl + "common/currencyList";

    axios.get(urlShringTxt, masterheaderconfig).then((res) => {
      var currencyList = [];
      if (res.data.status === "ok") {
        res.data.result.map((item) => {
          currencyList.push({
            label: item.currency_name,
            value: item.currency_name,
          });
          return "";
        });
      }
      this.setState({ currencyList: currencyList });
    }).catch((e) => {
      console.log(e)
    });
  }
  loadLanguage() {
    var urlShringTxt = apiUrl + "common/languagesList";

    axios.get(urlShringTxt, masterheaderconfig).then((res) => {
      var languageList = [];
      if (res.data.status === "ok") {
        res.data.result.map((item) =>
          languageList.push({
            label: item.language_name,
            value: item.language_code,
          })
        );
      }
      this.setState({ languageList: languageList });
    }).catch((e) => {
      console.log(e)
    });
  }
  loadAvailabilty() {
    var urlShringTxt = apiUrl + "availability/dropDownList";
    axios.get(urlShringTxt, masterheaderconfig).then((res) => {
      if (res.data.status === "ok") {
        this.setState({ availabiltyList: res.data.result });
      }
    }).catch((e) => {
      console.log(e)
    });
  }

  sateValChange = (field, value) => {
    if (field === "page") {
    }
  };

  handleChange(checked, name) {
    this.setState({ checked });
  }

  /* signin - start*/
  fieldChange = (field, value) => {
    this.setState(
      update(this.state, { clientdata: { [field]: { $set: value } } })
    );
  };
  handleSubmit = () => {
    showLoader("submit_frm", "class");
    var postData = this.state.clientdata;
    var postObject = {
      companyName: postData.companyName,
      companyUsername: postData.companyUsername,
      companyPassword: postData.companyPassword,
      companyEmail: postData.companyEmail,
      companyContactNumber:postData.companyContactNumber,
      companyWebSite:postData.companyWebSite,
      companyCountry:postData.companyCountry?.value ?? '',
      companyCurrency:postData.companyCurrency?.value ?? '',
      companyLanguage:postData.companyLanguage?.value ?? '',
      companyDateFormat:postData.companyDateFormat?.value ?? '',
      companyTimeFormat:postData.companyTimeFormat?.value ?? '',
      companyAvailability: postData.companyAvailability.length > 0 ? postData.companyAvailability.join(",") : "",
      companyEnableMenu: postData?.companyEnableMenu ?? false,
      companyEnableTAT: postData?.companyEnableTAT ?? false,
      companyEnableZoneValueBaseDeliveryCharge: postData?.companyEnableZoneValueBaseDeliveryCharge ?? false,
      companyEnableGuestCheckout: postData?.companyEnableGuestCheckout ?? false,
      companyEnableMaintenanceMode: postData?.companyEnableMaintenanceMode ?? false,
      companyEnablePromocode: postData?.companyEnablePromocode ?? false,
      companyEnableLoyalty: postData?.companyEnableLoyalty ?? false,      
      companyEnableNewSignupPromocode: postData?.companyEnableNewSignupPromocode ?? false,
      companyEnableHoliday: postData?.companyEnableHoliday ?? false,
      companyEnableOrderCount: postData?.companyEnableOrderCount ?? false,
      companyEnableTax: postData?.companyEnableTax ?? false,
      companyEnableHighlightProduct: postData?.companyEnableHighlightProduct ?? false,
      companyEnableProductTimeAvailability: postData?.companyEnableProductTimeAvailability ?? false,
      companyEnableProductspecialDays: postData?.companyEnableProductspecialDays ?? false,
      companyEnableProductRating: postData?.companyEnableProductRating ?? false,
      companyEnableStock: postData?.companyEnableStock ?? false,
      companyEnableRapyd : postData?.companyEnableRapyd ?? false,
      companyrapydmode: postData?.companyrapydmode ?? false,
      companyrapydaccesskey: postData?.companyrapydaccesskey ?? "",
      companyrapydsecretkey: postData?.companyrapydsecretkey ?? "",      
      companyEnableStripe:postData?.companyEnableStripe || false,
      companyStripeSecretKey: postData?.companyStripeSecretKey ?? "",
      companyStripePublicKey: postData?.companyStripePublicKey ?? "",
      companyStatus: postData.companyStatus?.value ?? "I",
    };
    var post_url = "company";
    let method = "post";
    if (this.state.editID !== "") {
      post_url = `company/${this.state.editID}`;
      method = 'update';
    }
    this.props.getFormPost(postObject, post_url, "master", method);
  };

  render() {
    return (
      <div className="layout-wrapper layout-content-navbar">
        <div className="layout-container">
          <Header {...this.props}  currentPage={"client"} />
          <div className="layout-page">
            <Topmenu />
            <div className="content-wrapper">
              <div className="container-xxl flex-grow-1 container-p-y">
                <div className="row mb-3">
                  <div className="col-lg-10 col-md-6">
                    <h4 className="fw-bold">
                      {this.state.editID !== "" ? "Update" : "Add New"} Client
                    </h4>
                  </div>
                  <div className="col-lg-2 col-md-6 text-end">
                    <Link to={"/masterpanel/client"}>
                      <button
                        type="button"
                        className="btn btn-outline-primary waves-effect"
                      >
                        Back
                      </button>
                    </Link>
                  </div>
                </div>
                <Form
                  {...this.props}
                  fields={this.state.clientdata}
                  onChange={this.fieldChange}
                  onValid={this.handleSubmit}
                  error_msg={this.state.error_msg}
                  countryList={this.state.countryList}
                  currencyList={this.state.currencyList}
                  languageList={this.state.languageList}
                  availabiltyList={this.state.availabiltyList}
                  onInvalid={() => {
                    setTimeout(function () {
                      if ($("#modulefrm .is-invalid").length > 0) {
                        $("html, body").animate(
                          {
                            scrollTop:
                              $(document)
                                .find("#modulefrm .is-invalid:first")
                                .offset().top - 100,
                          },
                          500
                        );
                      }
                    }, 500);
                  }}
                />
              </div>

              <Footer />
            </div>
          </div>
        </div>

        <div className="layout-overlay layout-menu-toggle"></div>

        <div className="drag-target"></div>
        <PageLoader pageloading={this.state.pageloading} />
      </div>
    );
  }
}

const mapStateTopProps = (state) => {
  return {
    formpost: state.formpost,
    detaildata: state.detaildata,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getFormPost: (formPayload, postUrl, authType, method) => {
      dispatch({ type: GET_FORMPOST, formPayload, postUrl, authType, method });
    },
    getDetailData: (datas) => {
      dispatch({ type: GET_DETAILDATA, datas });
    },
  };
};

export default connect(mapStateTopProps, mapDispatchToProps)(Clientform);

const isEmpty = (value) => (value === "" ? "This field is required." : null);
const minLength = (password, length) =>
  password.length >= length || password === ""
    ? null
    : "Password must be at least 6 characters.";
const areSame = (password, rePassword) =>
  password === rePassword ? null : "Password do not match.";
const isEmail = (email) =>
  validator.isEmail(email) ? null : "This is not a valid email.";

function validationConfig(props) {
  const {
    companyName,
    companyUsername,
    companyPassword,
    companyCPassword,
    companyEmail,
    companyStatus
  } = props.fields;
  if (props.fields.action === "add") {
    return {
      fields: [
        "companyName",
        "companyUsername",
        "companyPassword",
        "companyCPassword",
        "companyEmail",
        "companyStatus"
      ],

      validations: {
        companyName: [[isEmpty, companyName]],
        companyUsername: [[isEmpty, companyUsername]],
        companyPassword: [
          [isEmpty, companyPassword],
          [minLength, companyPassword, 6],
        ],
        companyCPassword: {
          rules: [
            [areSame, companyPassword, companyCPassword],
            [isEmpty, companyCPassword],
          ],
          fields: ["companyPassword", "companyCPassword"],
        },
        companyEmail: [
          [isEmpty, companyEmail],
          [isEmail, companyEmail],
        ],
        companyStatus: [[isSingleSelect, companyStatus]],
      },
    };
  } else {
    return {
      fields: [
        "companyName",
        "companyUsername",
        "companyPassword",
        "companyCPassword",
        "companyEmail",
        "companyStatus"
      ],

      validations: {
        companyName: [[isEmpty, companyName]],
        companyUsername: [[isEmpty, companyUsername]],
        companyPassword: [[minLength, companyPassword, 6]],
        companyCPassword: {
          rules: [[areSame, companyPassword, companyCPassword]],
          fields: ["companyPassword", "companyCPassword"],
        },
        companyEmail: [
          [isEmpty, companyEmail],
          [isEmail, companyEmail],
        ],
        companyStatus: [[isSingleSelect, companyStatus]],
      },
    };
  }
}

class Form extends Component {
  handleChange(name, value) {
    this.props.onChange(name, value);
  }
  handleSelectChange(name, value) {
    this.props.onChange(name, value);
  }
  handleChangeRadio(fields, name, value) {
    var selectedAvail = value.target.value;
    var companyAvailability = fields.companyAvailability;
    if (value.target.checked === true) {
      companyAvailability.push(value.target.value);
    } else {
      const indexNew = companyAvailability.indexOf(selectedAvail);
      companyAvailability.splice(indexNew, 1);
    }
    this.props.onChange(name, companyAvailability);
  }

  render() {
    const { fields, onChange, onValid, onInvalid, $field, $validation } =
      this.props;
    let errMsgName,
      errMsgUsername,
      errMsgPassword,
      errMsgConfirmPassword,
      errMssEmail,
      errMsgStatus = "";
    if ($validation.companyName.error.reason !== undefined) {
      errMsgName = $validation.companyName.show && (
        <span className="error">{$validation.companyName.error.reason}</span>
      );
    }

    if ($validation.companyUsername.error.reason !== undefined) {
      errMsgUsername = $validation.companyUsername.show && (
        <span className="error">
          {$validation.companyUsername.error.reason}
        </span>
      );
    }
    if ($validation.companyPassword.error.reason !== undefined) {
      errMsgPassword = $validation.companyPassword.show && (
        <span className="error">
          {$validation.companyPassword.error.reason}
        </span>
      );
    }
    if ($validation.companyCPassword.error.reason !== undefined) {
      errMsgConfirmPassword = $validation.companyCPassword.show && (
        <span className="error">
          {$validation.companyCPassword.error.reason}
        </span>
      );
    }
    if ($validation.companyEmail.error.reason !== undefined) {
      errMssEmail = $validation.companyEmail.show && (
        <span className="error">
          {$validation.companyEmail.error.reason}
        </span>
      );
    }
    if ($validation.companyStatus.error.reason !== undefined) {
      errMsgStatus = $validation.companyStatus.show && (
        <span className="error">{$validation.companyStatus.error.reason}</span>
      );
    }

    return (
      <form className="card-body fv-plugins-bootstrap5" id="modulefrm">
        <div
          className="accordion mt-3 accordion-header-primary"
          id="accordionStyle1"
        >
          <div className="accordion-item active">
            <h2 className="accordion-header">
              <button
                type="button"
                className="accordion-button"
                data-bs-toggle="collapse"
                data-bs-target="#accordionStyle1-3"
                aria-expanded="true"
              >
                Client Info
              </button>
            </h2>
            <div
              id="accordionStyle1-3"
              className="accordion-collapse collapse show"
              data-bs-parent="#accordionStyle1"
            >
              <div className="accordion-body">
                <div className="row g-3">
                  <div className="col-md-6">
                    <div className="form-floating form-floating-outline mb-4">
                      <input
                        type="text"
                        className={
                          errMsgName !== "" &&
                          errMsgName !== false &&
                          errMsgName !== undefined
                            ? "form-control is-invalid"
                            : "form-control"
                        }
                        name="companyName"
                        value={fields.companyName}
                        {...$field("companyName", (e) =>
                          onChange("companyName", e.target.value)
                        )}
                      />
                      <label htmlFor="companyName">
                        Client Name <span className="error">*</span>
                      </label>
                      {errMsgName}
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-floating form-floating-outline mb-4">
                      <input
                        type="text"
                        className={
                          errMsgUsername !== "" &&
                          errMsgUsername !== false &&
                          errMsgUsername !== undefined
                            ? "form-control is-invalid"
                            : "form-control"
                        }
                        name="companyUsername"
                        value={fields.companyUsername}
                        {...$field("companyUsername", (e) =>
                          onChange("companyUsername", e.target.value)
                        )}
                      />
                      <label htmlFor="companyUsername">
                        Username <span className="error">*</span>
                      </label>
                      {errMsgUsername}
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="mb-4 form-password-toggle">
                      <div className="input-group input-group-merge">
                        <div className="form-floating form-floating-outline">
                          <input
                            type="password"
                            id="companyPassword"
                            className={
                              errMsgPassword !== "" &&
                              errMsgPassword !== false &&
                              errMsgPassword !== undefined
                                ? "form-control is-invalid"
                                : "form-control"
                            }
                            value={fields.companyPassword}
                            {...$field("companyPassword", (e) =>
                              onChange("companyPassword", e.target.value)
                            )}
                          />
                          <label htmlFor="companyPassword">Password</label>
                          {errMsgPassword}
                        </div>
                        <span
                          className="input-group-text rounded-end cursor-pointer"
                          id="basic-default-password4"
                          style={{ height: "49px" }}
                        >
                          <i className="mdi mdi-eye-off-outline"></i>
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="mb-4 form-password-toggle">
                      <div className="input-group input-group-merge">
                        <div className="form-floating form-floating-outline">
                          <input
                            type="password"
                            id="companyCPassword"
                            className={
                              errMsgConfirmPassword !== "" &&
                              errMsgConfirmPassword !== false &&
                              errMsgConfirmPassword !== undefined
                                ? "form-control is-invalid"
                                : "form-control"
                            }
                            value={fields.companyCPassword}
                            {...$field("companyCPassword", (e) =>
                              onChange("companyCPassword", e.target.value)
                            )}
                          />
                          <label htmlFor="companyCPassword">
                            Confirm Password
                          </label>
                          {errMsgConfirmPassword}
                        </div>
                        <span
                          className="input-group-text rounded-end cursor-pointer"
                          id="basic-default-password3"
                          style={{ height: "49px" }}
                        >
                          <i className="mdi mdi-eye-off-outline"></i>
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-floating form-floating-outline mb-4">
                      <input
                        type="text"
                        className={
                          errMssEmail !== "" &&
                          errMssEmail !== false &&
                          errMssEmail !== undefined
                            ? "form-control is-invalid"
                            : "form-control"
                        }
                        name="companyEmail"
                        id="companyEmail"
                        value={fields.companyEmail}
                        {...$field("companyEmail", (e) =>
                          onChange("companyEmail", e.target.value)
                        )}
                      />
                      <label htmlFor="companyEmail">
                        Email ID <span className="error">*</span>
                      </label>
                      {errMssEmail}
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-floating form-floating-outline mb-4">
                      <input
                        type="text"
                        className="form-control"
                        name="companyContactNumber"
                        id="companyContactNumber"
                        value={fields.companyContactNumber}
                        {...$field("companyContactNumber", (e) =>
                          onChange("companyContactNumber", e.target.value)
                        )}
                      />
                      <label htmlFor="companyContactNumber">
                        Contact Number <span className="error">*</span>
                      </label>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-floating form-floating-outline mb-4">
                      <input
                        type="text"
                        className="form-control"
                        name="companyWebSite"
                        id="companyWebSite"
                        value={fields.companyWebSite}
                        {...$field("companyWebSite", (e) =>
                          onChange("companyWebSite", e.target.value)
                        )}
                      />
                      <label htmlFor="companyWebSite">
                      Web Site <span className="error">*</span>
                      </label>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-floating form-floating-outline">
                      <Select
                        value={fields.companyCountry}
                        onChange={this.handleSelectChange.bind(
                          this,
                          "companyCountry"
                        )}
                        placeholder="Select Country"
                        options={this.props.countryList}
                      />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-floating form-floating-outline">
                      <Select
                        value={fields.companyCurrency}
                        onChange={this.handleSelectChange.bind(
                          this,
                          "companyCurrency"
                        )}
                        placeholder="Select Currency"
                        options={this.props.currencyList}
                      />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-floating form-floating-outline">
                      <Select
                        value={fields.companyLanguage}
                        onChange={this.handleSelectChange.bind(
                          this,
                          "companyLanguage"
                        )}
                        placeholder="Select Language"
                        options={this.props.languageList}
                      />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-floating form-floating-outline">
                      <Select
                        value={fields.companyDateFormat}
                        onChange={this.handleSelectChange.bind(
                          this,
                          "companyDateFormat"
                        )}
                        placeholder="Select Date Format"
                        options={[
                          {
                            value: "LLLL d, yyyy",
                            label: format(todayDate, "LLLL d, yyyy"),
                          },
                          {
                            value: "yyyy-MM-dd",
                            label: format(todayDate, "yyyy-MM-dd"),
                          },
                          {
                            value: "MM/dd/yyyy",
                            label: format(todayDate, "MM/dd/yyyy"),
                          },
                          {
                            value: "MM/dd/yy",
                            label: format(todayDate, "MM/dd/yy"),
                          },
                          {
                            value: "dd/MM/yyyy",
                            label: format(todayDate, "dd/MM/yyyy"),
                          },
                          {
                            value: "dd-MM-yyyy",
                            label: format(todayDate, "dd-MM-yyyy"),
                          },
                        ]}
                      />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-floating form-floating-outline">
                      <Select
                        value={fields.companyTimeFormat}
                        onChange={this.handleSelectChange.bind(
                          this,
                          "companyTimeFormat"
                        )}
                        placeholder="Select Time Format"
                        options={[
                          {
                            value: "hh:mm a",
                            label: format(todayDate, "hh:mm a"),
                          },
                          {
                            value: "HH:mm",
                            label: format(todayDate, "HH:mm"),
                          },
                        ]}
                      />
                    </div>
                  </div>
                  <div
                    className={
                      errMsgStatus !== "" &&
                      errMsgStatus !== false &&
                      errMsgStatus !== undefined
                        ? "col-md-4 error-select error"
                        : "col-md-4"
                    }
                  >
                    <div className="form-floating form-floating-outline custm-select-box mt-4">
                      <Select
                        value={fields.companyStatus}
                        onChange={this.handleSelectChange.bind(
                          this,
                          "companyStatus"
                        )}
                        placeholder="Select Status"
                        options={[
                          { value: "A", label: "Active" },
                          { value: "I", label: "Inactive" },
                        ]}
                      />
                      <label className="select-box-label">
                        Status<span className="error">*</span>
                      </label>
                      {errMsgStatus}
                    </div>
                  </div>

                  <div className="col-md-12">
                    <h1 className="display-6 mb-0">
                      Availability<span className="error">*</span>
                    </h1>
                    <div className="row">
                      {this.props.availabiltyList.length > 0 &&
                        this.props.availabiltyList.map((item, index) => {
                          return (
                            <div className="col-md-2" key={index}>
                              <div className="form-check mt-3">
                                <input
                                  className="form-check-input"
                                  type="checkbox"
                                  value={item.value}
                                  id={"avail_" + index}
                                  checked={fields.companyAvailability.indexOf(item.value) >= 0 ? true : false}
                                  onChange={this.handleChangeRadio.bind(this, fields, "companyAvailability")}
                                />
                                <label
                                  className="form-check-label"
                                  htmlFor={"avail_" + index}
                                >
                                  {item.availabilityName}
                                </label>
                              </div>
                            </div>
                          );
                        })}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="accordion-item ">
            <h2 className="accordion-header">
              <button
                type="button"
                className="accordion-button collapsed"
                data-bs-toggle="collapse"
                data-bs-target="#accordionStyle1-1"
                aria-expanded="false"
              >
                Basic Settings
              </button>
            </h2>

            <div
              id="accordionStyle1-1"
              className="accordion-collapse collapse"
              data-bs-parent="#accordionStyle1"
            >
              <div className="accordion-body">
                <div className="row g-3">
                  <div className="col-md-3">
                    <div className="form-floating form-floating-outline mb-4">
                      <Switch
                        onChange={this.handleChange.bind(this, "companyEnableMenu")}
                        checked={fields.companyEnableMenu}
                        onColor="#666cff"
                        className="react-switch"
                        onHandleColor="#bdbfff"
                        boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                        activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                      />
                      <span>Enable Menu</span>
                    </div>
                  </div>
                  <div className="col-md-3">
                    <div className="form-floating form-floating-outline mb-4">
                      <Switch
                        onChange={this.handleChange.bind(this, "companyEnableTAT")}
                        checked={fields.companyEnableTAT}
                        onColor="#666cff"
                        className="react-switch"
                        onHandleColor="#bdbfff"
                        boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                        activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                      />
                      <span>Enable TAT Time</span>
                    </div>
                  </div>
                  <div className="col-md-3">
                    <div className="form-floating form-floating-outline mb-4">
                      <Switch
                        onChange={this.handleChange.bind(
                          this,
                          "companyEnableZoneValueBaseDeliveryCharge"
                        )}
                        checked={fields.companyEnableZoneValueBaseDeliveryCharge}
                        onColor="#666cff"
                        className="react-switch"
                        onHandleColor="#bdbfff"
                        boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                        activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                      />
                      <span>Enable Zone Order Value Base Delivery Charge</span>
                    </div>
                  </div>
                  <div className="col-md-3">
                    <div className="form-floating form-floating-outline mb-4">
                      <Switch
                        onChange={this.handleChange.bind(
                          this,
                          "companyEnableGuestCheckout"
                        )}
                        checked={fields.companyEnableGuestCheckout}
                        onColor="#666cff"
                        className="react-switch"
                        onHandleColor="#bdbfff"
                        boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                        activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                      />
                      <span>Enable Guest Checkout</span>
                    </div>
                  </div>
                  <div className="col-md-3">
                    <div className="form-floating form-floating-outline mb-4">
                      <Switch
                        onChange={this.handleChange.bind(
                          this,
                          "companyEnableMaintenanceMode"
                        )}
                        checked={fields.companyEnableMaintenanceMode}
                        onColor="#666cff"
                        className="react-switch"
                        onHandleColor="#bdbfff"
                        boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                        activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                      />
                      <span>Enable Maintenance Mode</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="accordion-item">
            <h2 className="accordion-header">
              <button
                type="button"
                className="accordion-button collapsed"
                data-bs-toggle="collapse"
                data-bs-target="#accordionStyle1-2"
                aria-expanded="false"
              >
                Promotion Settings
              </button>
            </h2>
            <div
              id="accordionStyle1-2"
              className="accordion-collapse collapse"
              data-bs-parent="#accordionStyle1"
            >
              <div className="accordion-body">
                <div className="row g-3">
                <div className="col-md-3">
                    <div className="form-floating form-floating-outline mb-4">
                      <Switch
                        onChange={this.handleChange.bind(
                          this,
                          "companyEnablePromocode"
                        )}
                        checked={fields.companyEnablePromocode}
                        onColor="#666cff"
                        className="react-switch"
                        onHandleColor="#bdbfff"
                        boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                        activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                      />
                      <span>Enable Promocode</span>
                    </div>
                  </div>
                  <div className="col-md-3">
                    <div className="form-floating form-floating-outline mb-4">
                      <Switch
                        onChange={this.handleChange.bind(
                          this,
                          "companyEnableLoyalty"
                        )}
                        checked={fields.companyEnableLoyalty}
                        onColor="#666cff"
                        className="react-switch"
                        onHandleColor="#bdbfff"
                        boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                        activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                      />
                      <span>Enable Loyalty</span>
                    </div>
                  </div>                  
                  <div className="col-md-3">
                    <div className="form-floating form-floating-outline mb-4">
                      <Switch
                        onChange={this.handleChange.bind(
                          this,
                          "companyEnableNewSignupPromocode"
                        )}
                        checked={fields.companyEnableNewSignupPromocode}
                        onColor="#666cff"
                        className="react-switch"
                        onHandleColor="#bdbfff"
                        boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                        activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                      />
                      <span>Enable New Signup Promocode</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="accordion-item ">
            <h2 className="accordion-header">
              <button
                type="button"
                className="accordion-button collapsed"
                data-bs-toggle="collapse"
                data-bs-target="#accordiontime"
                aria-expanded="false"
              >
                Time Settings
              </button>
            </h2>

            <div
              id="accordiontime"
              className="accordion-collapse collapse"
              data-bs-parent="#accordionStyle1"
            >
              <div className="accordion-body">
                <div className="row g-3">
                  <div className="col-md-3">
                    <div className="form-floating form-floating-outline mb-4">
                      <Switch
                        onChange={this.handleChange.bind(
                          this,
                          "companyEnableHoliday"
                        )}
                        checked={fields.companyEnableHoliday}
                        onColor="#666cff"
                        className="react-switch"
                        onHandleColor="#bdbfff"
                        boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                        activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                      />
                      <span>Enable Holiday</span>
                    </div>
                  </div>
                  <div className="col-md-3">
                    <div className="form-floating form-floating-outline mb-4">
                      <Switch
                        onChange={this.handleChange.bind(
                          this,
                          "companyEnableOrderCount"
                        )}
                        checked={fields.companyEnableOrderCount}
                        onColor="#666cff"
                        className="react-switch"
                        onHandleColor="#bdbfff"
                        boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                        activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                      />
                      <span>Enable Order Count</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="accordion-item ">
            <h2 className="accordion-header">
              <button
                type="button"
                className="accordion-button collapsed"
                data-bs-toggle="collapse"
                data-bs-target="#accordiontax"
                aria-expanded="false"
              >
                Tax Settings
              </button>
            </h2>

            <div
              id="accordiontax"
              className="accordion-collapse collapse"
              data-bs-parent="#accordionStyle1"
            >
              <div className="accordion-body">
                <div className="row g-3">
                  <div className="col-md-3">
                    <div className="form-floating form-floating-outline mb-4">
                      <Switch
                        onChange={this.handleChange.bind(this, "companyEnableTax")}
                        checked={fields.companyEnableTax}
                        onColor="#666cff"
                        className="react-switch"
                        onHandleColor="#bdbfff"
                        boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                        activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                      />
                      <span>Enable Tax</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="accordion-item ">
            <h2 className="accordion-header">
              <button
                type="button"
                className="accordion-button collapsed"
                data-bs-toggle="collapse"
                data-bs-target="#accordionproduct"
                aria-expanded="false"
              >
                Product Settings
              </button>
            </h2>

            <div
              id="accordionproduct"
              className="accordion-collapse collapse"
              data-bs-parent="#accordionStyle1"
            >
              <div className="accordion-body">
                <div className="row g-3">
                  <div className="col-md-3">
                    <div className="form-floating form-floating-outline mb-4">
                      <Switch
                        onChange={this.handleChange.bind(
                          this,
                          "companyEnableHighlightProduct"
                        )}
                        checked={fields.companyEnableHighlightProduct}
                        onColor="#666cff"
                        className="react-switch"
                        onHandleColor="#bdbfff"
                        boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                        activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                      />
                      <span>Enable Highlight Product</span>
                    </div>
                  </div>
                  <div className="col-md-3">
                    <div className="form-floating form-floating-outline mb-4">
                      <Switch
                        onChange={this.handleChange.bind(
                          this,
                          "companyEnableProductTimeAvailability"
                        )}
                        checked={fields.companyEnableProductTimeAvailability}
                        onColor="#666cff"
                        className="react-switch"
                        onHandleColor="#bdbfff"
                        boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                        activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                      />
                      <span>Enable Product Time Availability</span>
                    </div>
                  </div>
                  <div className="col-md-3">
                    <div className="form-floating form-floating-outline mb-4">
                      <Switch
                        onChange={this.handleChange.bind(
                          this,
                          "companyEnableProductspecialDays"
                        )}
                        checked={fields.companyEnableProductspecialDays}
                        onColor="#666cff"
                        className="react-switch"
                        onHandleColor="#bdbfff"
                        boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                        activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                      />
                      <span>Enable Product Special Days</span>
                    </div>
                  </div>
                  <div className="col-md-3">
                    <div className="form-floating form-floating-outline mb-4">
                      <Switch
                        onChange={this.handleChange.bind(
                          this,
                          "companyEnableProductRating"
                        )}
                        checked={fields.companyEnableProductRating}
                        onColor="#666cff"
                        className="react-switch"
                        onHandleColor="#bdbfff"
                        boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                        activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                      />
                      <span>Enable Product Rating</span>
                    </div>
                  </div>
                  <div className="col-md-3">
                    <div className="form-floating form-floating-outline mb-4">
                      <Switch
                        onChange={this.handleChange.bind(this, "companyEnableStock")}
                        checked={fields.companyEnableStock}
                        onColor="#666cff"
                        className="react-switch"
                        onHandleColor="#bdbfff"
                        boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                        activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                      />
                      <span>Enable Stock</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="accordion-item ">
            <h2 className="accordion-header">
              <button
                type="button"
                className="accordion-button collapsed"
                data-bs-toggle="collapse"
                data-bs-target="#accordionmembership"
                aria-expanded="false"
              >
                Payment Settings
              </button>
            </h2>
            <div
              id="accordionmembership"
              className="accordion-collapse collapse"
              data-bs-parent="#accordionStyle1"
            >
              <div className="accordion-body">
                <div className="row g-3">
                <div className="col-md-12">
                    <div className="form-floating form-floating-outline mb-4">
                      <Switch
                        onChange={this.handleChange.bind(
                          this,
                          "companyEnableRapyd"
                        )}
                        checked={fields.companyEnableRapyd}
                        onColor="#666cff"
                        className="react-switch"
                        onHandleColor="#bdbfff"
                        boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                        activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                      />
                      <span>Enable Rapyd</span>
                    </div>
                  </div>
                  {fields.companyEnableRapyd === true && (
                    <div className="row">
                      <div className="col-md-2">
                        <div className="form-floating form-floating-outline mb-4">
                          <Switch
                            onChange={this.handleChange.bind(
                              this,
                              "companyrapydmode"
                            )}
                            checked={fields.companyrapydmode}
                            onColor="#666cff"
                            className="react-switch"
                            onHandleColor="#bdbfff"
                            boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                            activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                          />
                          <span>Mode</span>
                        </div>
                      </div>
                      <div className="col-md-3">
                        <div className="form-floating form-floating-outline mb-4">
                          <input
                            type="text"
                            className="form-control"
                            name="companyrapydaccesskey"
                            id="companyrapydaccesskey"
                            value={fields.companyrapydaccesskey}
                            {...$field("companyrapydaccesskey", (e) =>
                              onChange("companyrapydaccesskey", e.target.value)
                            )}
                          />
                          <label htmlFor="companyrapydaccesskey">Access Key</label>
                        </div>
                      </div>
                      <div className="col-md-3">
                        <div className="form-floating form-floating-outline mb-4">
                          <input
                            type="text"
                            className="form-control"
                            name="companyrapydsecretkey"
                            id="companyrapydsecretkey"
                            value={fields.companyrapydsecretkey}
                            {...$field("companyrapydsecretkey", (e) =>
                              onChange("companyrapydsecretkey", e.target.value)
                            )}
                          />
                          <label htmlFor="companyrapydsecretkey">Secret Key</label>
                        </div>
                      </div>
                    </div>
                  )}
  
<div className="col-md-12">
                    <div className="form-floating form-floating-outline mb-4">
                      <Switch
                        onChange={this.handleChange.bind(
                          this,
                          "companyEnableStripe"
                        )}
                        checked={fields.companyEnableStripe}
                        onColor="#666cff"
                        className="react-switch"
                        onHandleColor="#bdbfff"
                        boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                        activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                      />
                      <span>Enable Stripe</span>
                    </div>
                  </div>
                  {fields.companyEnableStripe === true && (
                    <div className="row">
                      <div className="col-md-3">
                        <div className="form-floating form-floating-outline mb-4">
                          <input
                            type="text"
                            className="form-control"
                            name="companyStripeSecretKey"
                            id="companyStripeSecretKey"
                            value={fields.companyStripeSecretKey}
                            {...$field("companyStripeSecretKey", (e) =>
                              onChange("companyStripeSecretKey", e.target.value)
                            )}
                          />
                          <label htmlFor="companyStripeSecretKey">Secret Key</label>
                        </div>
                      </div>
                      <div className="col-md-3">
                        <div className="form-floating form-floating-outline mb-4">
                          <input
                            type="text"
                            className="form-control"
                            name="companyStripePublicKey"
                            id="companyStripePublicKey"
                            value={fields.companyStripePublicKey}
                            {...$field("companyStripePublicKey", (e) =>
                              onChange("companyStripePublicKey", e.target.value)
                            )}
                          />
                          <label htmlFor="companyStripePublicKey">Public Key</label>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="pt-4 text-end">
          <button
            type="button"
            className="btn btn-primary me-sm-3 me-1 waves-effect waves-light submit_frm"
            onClick={(e) => {
              e.preventDefault();
              this.props.$submit(onValid, onInvalid);
            }}
          >
            Submit
          </button>
          <Link to={"/masterpanel/client"}>
            <button
              type="reset"
              className="btn btn-label-secondary waves-effect"
            >
              Cancel
            </button>
          </Link>
        </div>
      </form>
    );
  }
}
Form = validated(validationConfig)(Form);
